import React, { useEffect, useRef, useState } from "react";
import {
  swalAlertDanger,
  swalConfirmationAlert,
} from "../../components/common/Alerts";
import { getData, postData } from "../../services/api.service";
import TableDataRender from "../../components/common/TableDataRender";
import { FaCheck, FaPrint, FaWhatsapp, FaClock, FaCheckCircle, FaTimesCircle, FaHome } from "react-icons/fa";
import Image from "../../assets/img/Logo.png";
import Logo from "../../assets/img/Logo2.png";
import { Link, useNavigate } from "react-router-dom";
import BackButton from "../../components/common/BackButton";
import RefreshButton from "../../components/common/RefreshButton";
import { useSelector } from "react-redux";
import { dateDMY, dateHHMM } from "../../services/date.service";

const CashierPendingOrders = () => {
  const tableRef = useRef();
  const dataUser = useSelector((state) => state.user.dataUser);
  const [orders, setOrders] = useState([]);
  const [viewMode, setViewMode] = useState("pending"); // 'pending', 'ready', 'cancelled'
  const navigate = useNavigate();

  // Funciones para convertir números a nombres
  const getPayMethodName = (payMethod) => {
    switch (Number(payMethod)) {
      case 1:
        return "Efectivo";
      case 2:
        return "Transferencia";
      default:
        return "No especificado";
    }
  };

  const getDeliveryName = (delivery) => {
    switch (Number(delivery)) {
      case 0:
        return "Retiro en local";
      case 1:
        return "Delivery";
      default:
        return "No especificado";
    }
  };

  const fetchData = async () => {
    try {
      if (
        dataUser === null ||
        (dataUser.role_id !== 3 && dataUser.role_id !== 1)
      ) {
        navigate("/");
      }

      const res = await getData("/api/get_orders_cashier");

      if (res.status === 200) {
        setOrders(res.data.orders);
      }
    } catch (error) {
      swalAlertDanger(
        "Error",
        "No se pudieron cargar los pedidos pendientes.",
        () => {}
      );
    }
  };

  // Filtrar pedidos según el modo de vista
  const getFilteredOrders = () => {
    switch (viewMode) {
      case "pending":
        return orders.filter(
          (order) => order.status === 1 || order.status === 2
        );
      case "ready":
        return orders.filter((order) => order.status === 3);
      case "cancelled":
        return orders.filter((order) => order.status === 5);
      default:
        return orders;
    }
  };

  const filteredOrders = getFilteredOrders();

  // Función para asignar color de fondo según el estado del pedido
  const getRowClass = (item) => {
    switch (Number(item.status)) {
      case 2: // En preparación
        return "table-warning";
      case 3: // Listo
        return "table-success";
      case 5: // Cancelado
        return "table-danger";
      default:
        return "";
    }
  };

  useEffect(() => {
    fetchData();

    // Configurar intervalo para actualizar los pedidos cada 30 segundos
    const interval = setInterval(() => {
      fetchData();
    }, 30000); // 30000 ms = 30 segundos

    // Función de limpieza para limpiar el intervalo cuando el componente se desmonte
    return () => {
      clearInterval(interval);
    };
  }, []);
  const getTitle = () => {
    switch (viewMode) {
      case "pending":
        return "Pedidos Pendientes";
      case "ready":
        return "Pedidos Listos";
      case "cancelled":
        return "Pedidos Cancelados";
      default:
        return "Pedidos";
    }
  };

  const getEmptyMessage = () => {
    switch (viewMode) {
      case "pending":
        return "No hay pedidos pendientes en este momento.";
      case "ready":
        return "No hay pedidos listos en este momento.";
      case "cancelled":
        return "No hay pedidos cancelados en este momento.";
      default:
        return "No hay pedidos en este momento.";
    }
  };

  if (filteredOrders.length === 0) {
    return (
      <div className="container mt-5 text-white">
        <Link to="/">
          <img src={Image} alt="logo" className="login-logo" />
        </Link>
        <h3 className="text-center">{getTitle()}</h3>
        <p className="text-center">{getEmptyMessage()}</p>
        
        <div className="d-flex gap-2 mb-3 flex-wrap">
          <BackButton />
          <RefreshButton onClick={fetchData} />
          <button
            className="btn btn-primary"
            onClick={() => navigate("/home/cashier")}
          >
            <FaHome className="me-2" />
            Panel
          </button>
        </div>

        {/* Botones de filtro mejorados */}
        <div className="d-flex gap-3 mb-4 justify-content-center flex-wrap">
          <button
            className={`btn ${
              viewMode === "pending" ? "btn-warning" : "btn-outline-warning"
            }`}
            onClick={() => setViewMode("pending")}
            style={{
              fontWeight: viewMode === "pending" ? "bold" : "normal",
              transform: viewMode === "pending" ? "scale(1.05)" : "scale(1)",
              transition: "all 0.2s ease",
              minWidth: "150px",
              boxShadow: viewMode === "pending" ? "0 4px 8px rgba(0,0,0,0.2)" : "none"
            }}
          >
            <FaClock className="me-2" />
            Pendientes
            {viewMode === "pending" && (
              <span className="badge bg-dark ms-2">0</span>
            )}
          </button>
          <button
            className={`btn ${
              viewMode === "ready" ? "btn-success" : "btn-outline-success"
            }`}
            onClick={() => setViewMode("ready")}
            style={{
              fontWeight: viewMode === "ready" ? "bold" : "normal",
              transform: viewMode === "ready" ? "scale(1.05)" : "scale(1)",
              transition: "all 0.2s ease",
              minWidth: "150px",
              boxShadow: viewMode === "ready" ? "0 4px 8px rgba(0,0,0,0.2)" : "none"
            }}
          >
            <FaCheckCircle className="me-2" />
            Pedidos Listos
            {viewMode === "ready" && (
              <span className="badge bg-dark ms-2">0</span>
            )}
          </button>
          <button
            className={`btn ${
              viewMode === "cancelled" ? "btn-danger" : "btn-outline-danger"
            }`}
            onClick={() => setViewMode("cancelled")}
            style={{
              fontWeight: viewMode === "cancelled" ? "bold" : "normal",
              transform: viewMode === "cancelled" ? "scale(1.05)" : "scale(1)",
              transition: "all 0.2s ease",
              minWidth: "150px",
              boxShadow: viewMode === "cancelled" ? "0 4px 8px rgba(0,0,0,0.2)" : "none"
            }}
          >
            <FaTimesCircle className="me-2" />
            Cancelados
            {viewMode === "cancelled" && (
              <span className="badge bg-dark ms-2">0</span>
            )}
          </button>
        </div>
      </div>
    );
  }

  const handlePrintCommand = async (item) => {
    const data = {
      order_id: item.id,
      status: 2, // Estado EN PROCESO
    };
    await postData("/api/order/change_status", data).then((res) => {
      fetchData();
    });
  };

  const handleCheckOrder = async (item) => {
    const data = {
      order_id: item.id,
      status: 3, // Estado LISTO
    };
    await postData("/api/order/change_status", data).then((res) => {
      fetchData();
    });
  };

  const columnMapping = {
   
    FECHA: { key: "production_date", dataType: "date", align: "center" },
    ENTREGA: {
      key: "delivery",
      dataType: "custom",
      align: "center",
      render: (item) => getDeliveryName(item.delivery),
    },
    PAGO: {
      key: "pay_method",
      dataType: "custom",
      align: "center",
      render: (item) => getPayMethodName(item.pay_method),
    },
    TOTAL: {
      key: "total_price",
      dataType: "number",
      align: "center",
      render: (item) => `$${item.total_price}`,
    },
    OBS: {
      key: "observations",
      dataType: "text",
      align: "center",
    },
    DIRECCION: {
      key: "order_address",
      dataType: "text",
      align: "center",
    },
    NOMBRE: {key:"name_client", dataType:"text", align:"center"},
    HORA: { key: "end_time", dataType: "time", align: "center" },
    // ESTADO: { key: "status_description", dataType: "text", align: "center" },

     "ID": {
      key: "id",
      dataType: "custom",
      align: "center",
      render: (item) => item.show_order_id || item.id,
    },
    ...(viewMode === "pending" && {
      C: {
        key: "edit",
        dataType: "button",
        align: "center",
        render: (item) => (
          <button
            onClick={() => {
              swalConfirmationAlert(
                "¿Imprimir Comanda?",
                "El pedido pasará a estado EN PROCESO",
                () => {
                  handlePrintCommand(item);
                }
              );
            }}
            className="btn btn-info"
          >
            <FaPrint />
          </button>
        ),
      },
      // LISTO: {
      //   key: "edit",
      //   dataType: "button",
      //   align: "center",
      //   render: (item) => (
      //     <button
      //       className="btn btn-success"
      //       onClick={() => {
      //         handleCheckOrder(item);
      //       }}
      //     >
      //       <FaCheck />
      //     </button>
      //   ),
      // },
    }),
    W: {
      key: "edit",
      dataType: "button",
      align: "center",
      render: (item) => (
        <button
          onClick={() => {
            console.log(item)
            const message = `Hola, su pedido con ID ${
              item.show_order_id || item.id
            } ha sido recibido y está siendo procesado. Fecha y hora de entrega: ${dateDMY(
              item.production_date
            )} ${dateHHMM(
              item.end_time
            )}. 
            TOTAL DEL PEDIDO: $${item.total_price}.
            Si tiene alguna pregunta, no dude en contactarnos. ¡Gracias por su preferencia!`;
            const phone = item.contact_phone;
            const url = `https://wa.me/${phone}?text=${encodeURIComponent(
              message
            )}`;
            window.open(url, "_blank");
          }}
          className="btn btn-success"
        >
          <FaWhatsapp />
        </button>
      ),
    },
    X: {
      key: "edit",
      dataType: "button",
      align: "center",
      render: (item) => (
        <button
          className="btn btn-danger"
          onClick={() => {
            swalConfirmationAlert(
              "¿Cancelar Pedido?",
              "El pedido pasará a estado CANCELADO",
              () => {
                const data = {
                  order_id: item.id,
                  status: 5, // Estado CANCELADO
                };
                postData("/api/order/change_status", data).then((res) => {
                  fetchData();
                });
              }
            );
          }}
        >
          X
        </button>
      ),
    },
  };

  return (
    <div className="mt-5 text-white">
      <Link to="/">
        <img src={Image} alt="logo" className="login-logo" />
      </Link>
      <h1 className="text-center">{getTitle()}</h1>
      <p className="text-center">
        Aquí podrás ver los pedidos{" "}
        {viewMode === "pending"
          ? "pendientes"
          : viewMode === "ready"
          ? "listos"
          : "cancelados"}
        .
      </p>
      <div className="d-flex gap-2 mb-3 flex-wrap">
        <BackButton />
        <RefreshButton onClick={fetchData} />
        <button
          className="btn btn-primary"
          onClick={() => navigate("/home/cashier")}
        >
          <FaHome className="me-2" />
          Panel
        </button>
      </div>

      {/* Botones de filtro mejorados */}
      <div className="d-flex gap-3 mb-4 justify-content-center flex-wrap">
        <button
          className={`btn ${
            viewMode === "pending" ? "btn-warning" : "btn-outline-warning"
          }`}
          onClick={() => setViewMode("pending")}
          style={{
            fontWeight: viewMode === "pending" ? "bold" : "normal",
            transform: viewMode === "pending" ? "scale(1.05)" : "scale(1)",
            transition: "all 0.2s ease",
            minWidth: "150px",
            boxShadow: viewMode === "pending" ? "0 4px 8px rgba(0,0,0,0.2)" : "none"
          }}
        >
          <FaClock className="me-2" />
          Pendientes
          {viewMode === "pending" && (
            <span className="badge bg-dark ms-2">{orders.filter(o => o.status === 1 || o.status === 2).length}</span>
          )}
        </button>
        <button
          className={`btn ${
            viewMode === "ready" ? "btn-success" : "btn-outline-success"
          }`}
          onClick={() => setViewMode("ready")}
          style={{
            fontWeight: viewMode === "ready" ? "bold" : "normal",
            transform: viewMode === "ready" ? "scale(1.05)" : "scale(1)",
            transition: "all 0.2s ease",
            minWidth: "150px",
            boxShadow: viewMode === "ready" ? "0 4px 8px rgba(0,0,0,0.2)" : "none"
          }}
        >
          <FaCheckCircle className="me-2" />
          Pedidos Listos
          {viewMode === "ready" && (
            <span className="badge bg-dark ms-2">{orders.filter(o => o.status === 3).length}</span>
          )}
        </button>
        <button
          className={`btn ${
            viewMode === "cancelled" ? "btn-danger" : "btn-outline-danger"
          }`}
          onClick={() => setViewMode("cancelled")}
          style={{
            fontWeight: viewMode === "cancelled" ? "bold" : "normal",
            transform: viewMode === "cancelled" ? "scale(1.05)" : "scale(1)",
            transition: "all 0.2s ease",
            minWidth: "150px",
            boxShadow: viewMode === "cancelled" ? "0 4px 8px rgba(0,0,0,0.2)" : "none"
          }}
        >
          <FaTimesCircle className="me-2" />
          Cancelados
          {viewMode === "cancelled" && (
            <span className="badge bg-dark ms-2">{orders.filter(o => o.status === 5).length}</span>
          )}
        </button>
      </div>
      <div className="mt-5 mb-5">
        <TableDataRender
          data={filteredOrders}
          columnMapping={columnMapping}
          tableRef={tableRef}
          getRowClass={getRowClass}
        />
      </div>
      <img src={Logo} alt="LogoBottom" className="w-50 d-flex mx-auto mt-5" />
    </div>
  );
};

export default CashierPendingOrders;
